// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__3SiUH","label":"LabeledBox_label__11guZ"};